import React from "react";
import { useSelector } from "react-redux";
import { AddToCart } from "../addToCart";
import { ShoppingCart } from "../shoppingCart";
import SingleProduct from "./singleProduct";

export default function Products() {
  const { products } = useSelector((state) => state.productsNCart);
  return (
    <>
      <div className="bg-gray-50 h-full md:h-screen">
        <div className="grid place-items-center">
          <h1 className="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4">
            Shopping Cart
          </h1>
        </div>
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
            {products.length > 0 &&
              products.map((product, index) => (
                <SingleProduct key={index} product={product} />
              ))}
          </div>
          <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
            <AddToCart />
            <ShoppingCart />
          </div>
        </div>
      </div>
    </>
  );
}
